<template>
  <div>
    <!-- <p>{{internalValue}}</p> -->
    <input
      type="date"
      v-if="mobile"
      v-model="internalValue"
      @change="$emit('change', internalValue);editMode=false"
    />
    <template v-else>
      <div v-show="!selectMode" class="date_inputs">
        <input
          placeholder="dd"
          v-model="day"
          ref="dd"
          class="date-part-input"
          @keydown="e=>filterKeyboard(e,'day')"
          @focus="thisDateisFocushed=true"
          @blur="thisDateisFocushed=false"
          :class="'date-part-input '+(thisDateisFocushed?'focushed':'')"
        />
        <input
          placeholder="mm"
          v-model="month"
          ref="mm"
          class="date-part-input"
          @keydown="e=>filterKeyboard(e,'month')"
          @focus="thisDateisFocushed=true"
          @blur="thisDateisFocushed=false"
          :class="'date-part-input '+(thisDateisFocushed?'focushed':'')"
        />
        <transition name="el-zoom-in-center">
          <input
            class="date-part-input"
            disabled
            v-model="prefixfullyear"
            ref="yyyy"
            v-if="prefixfullyear"
            v-show="prefixfullyear"
          />
        </transition>
        <input
          placeholder="yy"
          @keydown="e=>filterKeyboard(e,'year')"
          v-model="year"
          ref="yy"
          @focus="thisDateisFocushed=true"
          xblur="thisDateisFocushed=false"
          :style="'width:'+(prefixfullyear?'30':'50')+'px'"
          :class="'date-part-input '+(thisDateisFocushed?'focushed':'')"
        />
        <el-button
          icon="el-icon-date"
          type="info"
          plain
          @click="goSelect()"
          ref="calbtn"
          :id="'calbtn'+udx"
        ></el-button>
      </div>
      <el-date-picker
        ref="date_component"
        v-show="selectMode"
        v-model="internalValue"
        type="date"
        @blur="selectMode=false"
        style="width:100%"
        @change="$emit('change', internalValue);selectMode=false"
        value-format="yyyy-MM-dd"
        format="d.M.yyyy"
        placeholder="Select date"
        :default-value="new Date()"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "s-date-time",

  props: {
    value: { default: null },
    mobile: { type: Boolean, default: false }
  },

  data: () => ({
    udx: Date.now() + Math.random(),
    selectMode: false,
    day: null,
    thisDateisFocushed:false,
    month: null,
    year: null,
    fullyear: null,
    internalValue: false,
    editMode: false,
    lastCursorPos: { month: null, year: null, day: null },
    valid: { mm: false, dd: false, yy: false }
  }),
  computed: {
    prefixfullyear() {
      if ((this.year + "").length < 3)
        return ("" + this.fullyear).substring(0, 2);
      return null;
    }
  },
  methods: {
    goSelect() {
      this.selectMode = true;
      this.$nextTick(() => {
        this.$refs.date_component.focus();
      });
    },
    findNextTabStop(activeElem, reverse) {
      /*check if an element is defined or use activeElement*/
      // activeElem =
      //   activeElem instanceof HTMLElement ? activeElem : document.activeElement;
      const eludx = "calbtn" + this.udx;
      let queryString = [
          'a:not([disabled]):not([tabindex="-1"])',
          'button:not([disabled]):not([tabindex="-1"])',
          'input:not([disabled]):not([tabindex="-1"])',
          'select:not([disabled]):not([tabindex="-1"])',
          '[tabindex]:not([disabled]):not([tabindex="-1"])'
          /* add custom queries here */
        ].join(","),
        foundActive = false,
        queryResult = Array.prototype.filter.call(
          document.querySelectorAll(queryString),
          elem => {
            if (elem.getAttribute("id") == eludx) {
              foundActive = true;
              return false;
            }
            /*check for visibility while always include the current activeElement*/
            return (
              (elem.offsetWidth > 0 || elem.offsetHeight > 0) && foundActive
            );
          }
        ),
        indexedList = queryResult
          .slice()
          .filter(elem => {
            /* filter out all indexes not greater than 0 */
            return elem.tabIndex == 0 || elem.tabIndex == -1 ? false : true;
          })
          .sort((a, b) => {
            /* sort the array by index from smallest to largest */
            return a.tabIndex != 0 && b.tabIndex != 0
              ? a.tabIndex < b.tabIndex
                ? -1
                : b.tabIndex < a.tabIndex
                ? 1
                : 0
              : a.tabIndex != 0
              ? -1
              : b.tabIndex != 0
              ? 1
              : 0;
          }),
        focusable = [].concat(
          indexedList,
          queryResult.filter(elem => {
            /* filter out all indexes above 0 */
            return elem.tabIndex == 0 || elem.tabIndex == -1 ? true : false;
          })
        );
      return queryResult[0];
      /* if reverse is true return the previous focusable element
     if reverse is false return the next focusable element */
      // return reverse
      //   ? focusable[focusable.indexOf(activeElem) - 1] ||
      //       focusable[focusable.length - 1]
      //   : focusable[focusable.indexOf(activeElem) + 1] || focusable[0];
    },
    filterKeyboard(event, place) {
      const cp = event.target.selectionStart,
        nextRefs = { month: "yy", day: "mm" },
        prevRefs = { month: "dd", year: "mm" },
        limit = (this[place] + "").length;
      _log_(
        "k.." + event.key,
        place,
        this.lastCursorPos[place],
        ">",
        cp,
        event.target.selectionEnd,
        (this[place] + "").length
      );
      this.lastCursorPos[place] = cp;
      if (event.key == "Tab") {
        event.preventDefault();
        const nel = this.findNextTabStop(this.$refs["calbtn"]);
        _log_("tab..", nel);
        if (nel) nel.focus();
        return;
      }
      if (
        event.key == "ArrowRight" ||
        event.key == "." ||
        event.key == "Delete"
      ) {
        if (cp == limit && nextRefs[place]) {
          if (event.key == "Delete") {
            const valf = place == "day" ? "month" : "year";
            var val = this[valf] + "";
            if (val && val.length) this[valf] = val.substring(1, val.length);
          }
          this.setCaretPosition(nextRefs[place], 0);
        }
        if (event.key == ".") event.preventDefault();
        return;
      }

      if (event.key == "ArrowLeft" || event.key == "Backspace") {
        if (cp == 0 && prevRefs[place]) {
          if (event.key == "Backspace") {
            const valf = place == "month" ? "day" : "year";
            var val = this[valf] + "";
            if (val && val.length)
              this[valf] = val.substring(0, val.length - 1);
          }
          //  this.$refs[prevRefs[place]].focus();
          this.setCaretPosition(prevRefs[place], 2);
        }
        return;
      }
      if (
        (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        // event.keyCode != 46 &&
        event.keyCode != 44
      ) {
        event.preventDefault();
      }
      if (event.keyCode == 44) {
        //event.keyCode == 46 ||
        // _log_("k.C.F." + this.content);
        if (this.formatgreek && this.content.indexOf(",") > -1)
          event.preventDefault();
        // if (!this.formatgreek && this.content.indexOf(".") > -1)
        //   event.preventDefault();
      }
    },
    setCaretPosition(ref, caretPos) {
      var range,
        elem = this.$refs[ref],
        vm = this;
      _log_("k.C.F.", elem);
      vm.$nextTick(() => {
        if (elem.createTextRange) {
          range = elem.createTextRange();
          range.move("character", caretPos);
          range.select();
        } else {
          elem.focus();
          if (elem.selectionStart !== undefined) {
            elem.setSelectionRange(caretPos, caretPos);
          }
        }
      });
    },
    focus() {
      this.editMode = true;
      this.goFocus();
    },
    goFocus() {
      const vm = this;
      vm.$nextTick(() => {
        if (vm.selectMode) vm.$refs.date_component.focus();
        else vm.$refs.dd.focus();
      });
    },
    lastday() {
      if (this.month && this.fullyear)
        return new Date(this.year, this.month, 0).getDate();
    },
    setTheValues(v) {
      _log_("what date:", v);
      if (v) {
        // initial set
        this.internalValue = v;
        const dps = v.split("-");
        this.day = dps[2];
        this.month = dps[1];
        this.year = this.year ? this.year : dps[0];
      } else {
        if (this.year) this.year = parseInt(this.year);
        else return;
        if (this.month) this.month = parseInt(this.month);
        else return;
        if (this.day) this.day = parseInt(this.day);
        else return;
        if (this.year.length < 3) return;
        if (this.year < 100) {
          if (this.year < 40) this.fullyear = 2000 + this.year;
          else if (this.year >= 40) this.fullyear = 1900 + this.year;
        } else this.fullyear = this.year;

        const theLastDayIS = this.lastday();
        if (this.day > theLastDayIS) this.day = theLastDayIS;

        this.internalValue = this.fullyear + "-" + this.month + "-" + this.day;
        this.$emit("input", this.internalValue);
        this.$emit("change", this.internalValue);
      }
    }
  },
  watch: {
    value(val, oldval) {
      if (val == oldval) return;
      this.setTheValues(this.value);
    },
    year(val, oldval) {
      if (!val || val == oldval) return;
      if (val.length > 4) {
        this.year = oldval;
      }
      this.setTheValues();
    },
    day(val, oldval) {
      const intval = parseInt(val);
      if (!val || val == oldval) return;
      if (val.length > 2) {
        this.day = val.substring(0, 2);

        this.month = val.substring(2, val.length);
        this.$nextTick(() => {
          this.$refs.mm.focus();
        });
      } else if (intval < 1 || intval > 31) {
        this.day = oldval;
        return;
      }
      this.setTheValues();
    },
    month(val, oldval) {
      const intval = parseInt(val);
      if (!val || val == oldval) return;
      if (val.length > 2) {
        this.month = val.substring(0, 2);

        this.year = val.substring(2, val.length);
        this.$nextTick(() => {
          this.$refs.yy.focus();
        });
      } else if (intval < 1 || intval > 12) {
        this.month = oldval;
        return;
      }
      this.setTheValues();
    }
    // internalValue(val, oldVal) {
    //   // _log_("what dat:", val);
    //   if (val !== oldVal) {
    //     this.$emit("input", val);
    //   }
    // }
  },

  created() {
    _log_("what dat-----:", this.internalValue);
    this.setTheValues(this.value);
  }
};
</script>
<style >
input.date-part-input {
  width: 30px;
  color: #606266;
  font-size: 14px;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 7px;
}
input.date-part-input.focushed {
  border-bottom-color: #409eff;
}
.date_inputs input:focus {
  /* border:none; */
  box-shadow: none !important;
  outline: none !important;
}
</style>